import { createContext } from 'react';

import { SelectionStore } from './Selection';
import { DatasetStore } from './Dataset';
import { DimensionsStore } from './Dimensions';
import { DebuggingStore } from './Debugging';

export class RootStore {
  // main = new MainStorage(this)
  // flow = new FlowStorage(this)
  // concept = new ConceptMapStorage(this)
  // structure = new StructureStorage(this)
  dataset = new DatasetStore(this)  
  selection = new SelectionStore(this)
  dimensions = new DimensionsStore(this)
  debugging = new DebuggingStore(this)
}

const RootStoreContext = createContext(new RootStore());

export default RootStoreContext;